module.exports = __webpack_public_path__ + "static/media/04.b4d4f052.gif";